import { render, staticRenderFns } from "./AssignedClassSettingDetail.vue?vue&type=template&id=d9852baa&scoped=true&"
import script from "./AssignedClassSettingDetail.vue?vue&type=script&lang=js&"
export * from "./AssignedClassSettingDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignedClassSettingDetail.vue?vue&type=style&index=0&id=d9852baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9852baa",
  null
  
)

export default component.exports